import React, { useState } from 'react';
import * as ApiCalls from '../utils/ApiCalls';
import ConsultForm from '../components/ConsultForm';
import SkuCalculatorResult from '../components/SkuCalculatorResult';

const ConsultContainer = () => {
  const [consultationId, setConsultationId] = useState('');
  const [validationError, setValidationError] = useState('');
  const { callApi, loading, data, error, reset } = ApiCalls.cptCode();

  const handleChange = (e) => {
    setConsultationId(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!consultationId) {
      setValidationError('Consultation ID is required');
      return;
    }

    reset();
    setValidationError('');
    callApi({ consultation_id: consultationId });
  };

  return (
    <div>
      <ConsultForm
        consultationId={consultationId}
        loading={loading}
        error={validationError}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
      {error && <p className="error">Error: {error.message}</p>}
      {data && <SkuCalculatorResult data={data} />}
    </div>
  );
}

export default ConsultContainer;
